<template>
  <v-card elevation="0">
    <v-dialog v-model="dialog" max-width="500">
      <Confirm
          title="Salvar"
          message="Tem certeza de que deseja salvar estes dados?"
          buttonText="Salvar"
          @cancel="dialog = false"
          @action="submit"
      />
    </v-dialog>

    <v-form
        class="form"
        ref="address"
        lazy-validation
    >
      <v-row class="pa-4 pb-0 ma-0">
        <v-col cols="12">
          <v-icon color="normalred">mdi-google-maps</v-icon>
          <span class="step-title">Endereço</span>
          <br/>
          <span class="step-subtitle ml-3">Informações sobre endereço</span>
          <br/>
        </v-col>

        <v-col cols="12" sm="12" md="12" lg="12">
          <span class="label">CEP<strong style="color: #bc0000">*</strong></span>
          <span class="step-subtitle">(Informe seu CEP para preenchimento automático ou
            <strong class="type-manually" @click="typeManually = true">Digite Manualmente</strong>)
          </span>

          <div class="d-flex align-center mt-2">
            <v-text-field
                dense
                style="max-width: 240px"
                outlined
                :rules="[rules.postalCodeRules]"
                v-model="currentUser.postalCode"
                v-on:keyup="searchCEP"
                v-mask="this.isEditing ? cepMask : '#####-###'"
                class="inputCep"
            ></v-text-field>
            <a
                class="type-manually ml-3"
                style="text-decoration: none"
                href="https://buscacepinter.correios.com.br/app/endereco/index.php"
                target="_blank"
            >Não sei meu CEP</a>
          </div>
          <p v-show="naoLocalizado" style="display: none; background-color: #f1948a">
            <strong>CEP não localizado.</strong> Por gentileza entre manualmente.
          </p>
        </v-col>
        <v-col cols="12" sm="12" md="2" lg="2">
          <span class="label">Estado<strong style="color: #bc0000">*</strong></span>

          <v-select
              dense
              outlined
              :disabled="!typeManually"
              :rules="[rules.required]"
              :items="estados"
              v-model="currentUser.state"
              color="secondary"
              id="mb-8"
              required
          ></v-select>
        </v-col>
        <v-col cols="12" sm="12" md="5" lg="5">
          <span class="label">Cidade<strong style="color: #bc0000">*</strong></span>
          <v-text-field
              dense
              outlined
              :disabled="!typeManually"
              :rules="[rules.required]"
              v-model="currentUser.city"
              color="secondary"
              id="inputCidade"
              type="text"
              required
          ></v-text-field>
        </v-col>

        <v-col cols="12" sm="12" md="5" lg="5">
          <span class="label">Bairro<strong style="color: #bc0000">*</strong></span>
          <v-text-field
              dense
              :disabled="!typeManually"
              outlined
              :rules="[rules.required]"
              v-model="currentUser.neighborhood"
              id="inputBairro"
              color="secondary"
              type="text"
              required
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="12" md="6" lg="6">
          <span class="label">Logradouro<strong style="color: #bc0000">*</strong></span>
          <v-text-field
              dense
              :disabled="!typeManually"
              outlined
              :rules="[rules.required]"
              color="secondary"
              v-model="currentUser.addressName"
              id="inputLogradouro"
              type="text"
              required
          ></v-text-field>
        </v-col>

        <v-col cols="12" sm="12" md="3" lg="3">
          <span class="label">Número<strong style="color: #bc0000">*</strong></span>
          <v-text-field
              dense
              outlined
              v-model="currentUser.addressNumber"
              color="secondary"
              id="AddressNumber"
              type="number"
              :required="true"
          ></v-text-field>
        </v-col>

        <v-col
            class="d-flex align-center justify-center"
            cols="12"
            sm="12"
            md="3"
            lg="3"
        >
          <v-checkbox
              dense
              outlined
              class="black--text"
              v-model="hasAddressNumber"
          ></v-checkbox>
          <span class="label mt-4"> Sem número </span>
        </v-col>

        <v-col cols="12" sm="12" md="12" lg="12">
          <span class="label"> Complemento </span>
          <v-text-field
              dense
              :disabled="!typeManually"
              outlined
              v-model="currentUser.addressComplement"
              id="inputComplemento"
              color="secondary"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row class="pb-3" justify="center">
        <v-col cols="12" md="6">
          <v-btn
              class="primary-button"
              color="normalred"
              elevation="0"
              @click="validate()"
              block
          >
            Salvar
          </v-btn>
        </v-col>
      </v-row>
    </v-form>
  </v-card>
</template>

<script>
import ApiService from "../../../../services/ApiService";
import Vue from "vue";
import Confirm from "../../components/ConfirmExit.vue";
import {findLatitudeAndLongitude} from "../../../../services/GoogleMaps";

export default {
  name: "Address",
  components: {
    Confirm,
  },
  props: {},
  data: () => ({
    typeManually: false,
    naoLocalizado: false,
    hasAddressNumber: true,
    loading: true,
    currentUser: {
      image: "",
      Name: "",
      defaultFrete: "",
      agreement: false,
      cnpj: "",
      inscrEstadual: "",
      phoneNumber: "",
      phoneNumber2: "",
      birthDate: "",
      postalCode: "",
      state: "",
      city: "",
      neighborhood: "",
      addressName: "",
      addressNumber: "",
      country: "",
      addressComplement: "",
      resaleRegion: "",
      category: "",
      region: "",
      password: "",
      password2: "",
      email: "",
      email2: "",
      resaleWebSite: "",
      receiveEmail: "",
      receiveSms: "",
      textObservation: "",
      tokenMelhorEnvio: "",
      latitude: null,
      longitude: null,
    },
    apiService: new ApiService(),
    user: {},
    dialog: false,
    userTypeMaster: 0,
    userTypeAdmin: 1,
    userTypeResale: 2,
    userTypeInstaller: 3,
    specialties: [],
    isEditing: false,
    rules: {
      nameRules: (v) => (v && v.length <= 128) || "Nome deve ter no máximo 128 caracteres",
      required: (value) => !!value || "Campo requerido.",
      min: (v) => v.length >= 4 || "Minimo de 4 caracteres.",
      postalCodeRules: (v) => (v && v.length <= 10) || "CEP deve ter no máximo 10 caracteres",
    },
    estados: [
      "AC",
      "AL",
      "AM",
      "AP",
      "BA",
      "CE",
      "DF",
      "ES",
      "GO",
      "MA",
      "MT",
      "MS",
      "MG",
      "PA",
      "PB",
      "PR",
      "PE",
      "PI",
      "RJ",
      "RN",
      "RO",
      "RS",
      "RR",
      "SC",
      "SE",
      "SP",
      "TO",
    ],
  }),
  async created() {
    await this.updateUser();
    this.user = JSON.parse(localStorage.getItem("user"));
  },
  methods: {
    async updateUser() {
      this.loading = true;
      let user = JSON.parse(localStorage.getItem("user"));

      let url;

      switch (user.type) {
        case 0:
          url = "user/get-one";
          break;
        case 1:
          url = "user/get-one";
          break;
        case 2:
          url = "resale/get-one";
          break;
        case 3:
          url = "installer/get-one";
          break;
      }

      this.Id = user.id;
      await this.apiService.get(`${url}?id=${this.Id}`).then((response) => {
        this.currentUser = response;
        this.specialties = this.currentUser.specialties
        this.loading = false;
      });
    },
    validate() {
      if (this.$refs.address.validate()) {
        this.dialog = true;
      } else {
        Vue.$globalEvent.$emit("onFlashMessage", {
          type: "error",
          title: "Formulário não validado",
          message: "Confira o preenchimento",
          trace: null,
        });
      }
    },

    async searchCEP() {
      this.cepMask = "#####-###";
      if (/^[0-9]{5}-[0-9]{3}$/.test(this.currentUser.postalCode)) {
        const self = this;
        self.naoLocalizado = false;
        self.location = {};
        const client = new ApiService();
        await client
            .get(`user/postalcode?cep=${this.currentUser.postalCode}`)
            .then((response) => {
              const location = JSON.parse(response);

              if (location.erro) {
                self.location = {};
                this.naoLocalizado = true;
                this.currentUser.neighborhood = "";
                this.currentUser.address = "";
                this.currentUser.city = "";
                this.currentUser.state = "";
                this.currentUser.addressNumber = "";
                this.currentUser.country = "Brasil";
                this.currentUser.addressName = "";
                return;
              }

              this.currentUser.neighborhood = location.bairro;
              this.currentUser.addressName = location.logradouro;
              this.currentUser.city = location.localidade;
              this.currentUser.state = location.uf;
              this.currentUser.country = "Brasil";
              document.getElementById("AddressNumber").focus();

              this.typeManually = true;
              return;
            });
      }
    },

    async submit() {
      try {
        const {lat,lng} = await findLatitudeAndLongitude(this.currentUser);

        this.currentUser.latitude = lat ? parseFloat(lat) : null;
        this.currentUser.longitude = lng ? parseFloat(lng) : null;
        let model = this.currentUser;
        let url = '';
        switch (model.type) {
          case this.userTypeMaster:
          case this.userTypeAdmin:
            url = "user/edit";
            break;
          case this.userTypeResale:
            url = "resale/edit-user-resale";
            break;
          case this.userTypeInstaller:
            url = "installer/edit";
            this.currentUser.specialties = [];
            this.specialties.forEach((x) => {
              this.currentUser.specialties.push({
                specialtiesId: x.specialtiesId,
                installerId: this.currentUser.id,
              });
            });
            break;
        }
        await this.apiService.post(url, model)
          .then((resp) => {
            Vue.$globalEvent.$emit("onFlashMessage", {
              type: "success",
              title: resp.message,
              message: resp.message,
              trace: null,
            });

            this.dialog = false;
            this.loading = false;
            })
          .catch((err) => {
            Vue.$globalEvent.$emit("onFlashMessage", {
              type: "error",
              title: "Erro ao cadastrar produto",
              message: err.body.message,
              trace: null,
            });

            this.dialog = false;
            this.loading = false;
          });
        await this.updateUser();
      } catch (e) {

      }
    },
  },
};
</script>
<style scoped>
</style>
